/* ==========================================================================
   header-scroll.js — Scroll-responsive header logo sizing
   Mirrors the live site behavior: logo shrinks from brandSizeMax to
   brandSizeMin as the user scrolls, using --brand-size CSS variable.
   ========================================================================== */

(function () {
  'use strict';

  // Only run on desktop (mobile uses fixed brand size)
  var mql = window.matchMedia('(min-width: 769px)');

  var root = document.documentElement;
  var ticking = false;

  function getBrandValues() {
    var styles = getComputedStyle(root);
    return {
      max: parseFloat(styles.getPropertyValue('--brand-size-max')),
      min: parseFloat(styles.getPropertyValue('--brand-size-min'))
    };
  }

  function update() {
    var brand = getBrandValues();
    var scrollY = window.scrollY || window.pageYOffset;
    var brandSize = Math.max(
      Math.min(brand.max - 0.015 * scrollY, brand.max),
      brand.min
    );
    root.style.setProperty('--brand-size', brandSize + 'rem');
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }

  function enable() {
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  }

  function disable() {
    window.removeEventListener('scroll', onScroll);
    root.style.removeProperty('--brand-size');
    ticking = false;
  }

  function handleMediaChange(e) {
    if (e.matches) {
      enable();
    } else {
      disable();
    }
  }

  if (mql.matches) {
    enable();
  }

  if (mql.addEventListener) {
    mql.addEventListener('change', handleMediaChange);
  } else if (mql.addListener) {
    mql.addListener(handleMediaChange);
  }
})();
